import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl, getHeader } from "../utils/api";

export const getPaymnetDetails = () => async () => {
  try {
    const header = await getHeader();
    const response = await axios.get(`${baseUrl}/payment/details`, {
      headers: header,
    });
    if (response?.status === 200 || response?.status === 201) {
      //   dispatch(registerUserAction(response?.data?.user))
      return response?.data?.user;
    }
  } catch (error) {
    if (error?.response?.data) {
      const errorMessage = error.response.data.message;
      toast.error(errorMessage);
    }
  }
};

export const oneTimePayment =
  ({ amount, centerId,usercomment,_id,email }) =>
  async () => {
    try {
      const header = await getHeader();
      const response = await axios.post(
        `${baseUrl}/payment/one-time`,
        {
          amount,
          centerId,
          usercomment,
          _id,
          email
        },
        {
          headers: header,
        }
      );
      if (response?.status === 200 || response?.status === 201) {
        return response;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
        toast.error(errorMessage)
      }
    }
  };

  export const paypalPayment =
  ({ amount, centerId,usercomment,_id,email,status,books}) =>
  async () => {
    try {
      const header = await getHeader();
      const response = await axios.post(
        `${baseUrl}/payment/paypal`,
        {
          amount,
          ...(centerId && { centerId }),
          usercomment,
          _id,
          email,
          status,
          books
        },
        {
          headers: header,
        }
      );
      if (response?.status === 200 || response?.status === 201) {
        return response;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
        toast.error(errorMessage)
      }
    }
  };

  

  export const AdminPayment =
  ({ amount,email,id,centerId,books, usercomment,fullName,sendInvoiceConsent
}) =>
  async () => {
    try {
      const header = await getHeader();
      const response = await axios.post(
        `${baseUrl}/payment/admin-one-time`,
        {
          amount,
          email,
          fullName,
          id,
          ...(centerId && { centerId }),
          books,
          usercomment,
          sendInvoiceConsent
        },
        {
          headers: header,
        }
      );
      if (response?.status === 200 || response?.status === 201) {
        return response;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
        toast.error(errorMessage)
      }
    }
  };

 

export const createSubscription =
  ({ amount, interval, centerId,usercomment,_id,email }) =>
  async () => {
    try {
      const header = await getHeader();
      const response = await axios.post(
        `${baseUrl}/payment/subscription`,
        {
          amount,
          centerId,
          interval,
          usercomment,
          _id,
          email
        },
        {
          headers: header,
        }
      );
      if (response?.status === 200 || response?.status === 201) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
        toast.error(errorMessage)
      }
    }
  };


  export const createAdminSubscription =
  ({ amount, interval, email,id,centerId,books, usercomment,sendInvoiceConsent,fullName}) =>
  async () => {
    try {
      const header = await getHeader();
      const response = await axios.post(
        `${baseUrl}/payment/adminsubscription`,
        {
          amount,
          email,
          interval,
          fullName,
          id,
          ...(centerId && { centerId }),
          books,
          usercomment,
          sendInvoiceConsent
         
        },
        {
          headers: header,
        }
      );
      if (response?.status === 200 || response?.status === 201) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
        toast.error(errorMessage)
      }
    }
  };


  export const getRecentTransaction = ({id}) => async () => {
    try {
      const response = await axios.get(`${baseUrl}/admin/recent-transactions/${id}`,);
      if (response?.status === 200 || response?.status === 201) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
      }
    }
  };

  

  export const getSubscriptions = ({id}) => async () => {
    try {
      const header = await getHeader();
      const response = await axios.get(`${baseUrl}/users/subscriptions/${id}`,
        {
          headers: header,
        }

      );
      if (response?.status === 200 || response?.status === 201) {
        return response?.data?.result;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
      }
    }
  };

  export const cancelSubscriptions = ({id}) => async () => {
    try {
      const header = await getHeader();
      const response = await axios.delete(`${baseUrl}/payment/cancel-subscription/${id}`,
        {
          headers: header,
        }

      );
      if (response?.status === 200 || response?.status === 201) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
      }
    }
  };

  export const getTotalTransactionandPercentage =
  ({ id }) =>
  async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/admin/transaction/amount/${id}`,
      );

      if (response?.status === 200 || response?.status === 201) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorMessage = error.response.data.message;
        //    toast.error(errorMessage)
      }
    }
  };
  export const fetchConnectedAccount = async ({id}) => {
    try {
        const header = await getHeader();
      const response =  await axios.get(
        `${baseUrl}/admin/getconnect/${id}`,
        { headers: header }
      
      );
        
      return response.data;
    } catch (error) {
      throw error;
    }
  };


  // export const paypalSubscription =
  // ({ amount, centerId, usercomment, _id, email, subscriptionId, status, books }) =>
  // async () => {
  //   try {
  //     const header = await getHeader();
  //     const response = await axios.post(
  //       `${baseUrl}/payment/paypal-subscription`,
  //       {
  //         amount,
  //         ...(centerId && { centerId }),
  //         usercomment,
  //         _id,
  //         email,
  //         subscriptionId,
  //         status,
  //         books
  //       },
  //       {
  //         headers: header,
  //       }
  //     );
  //     if (response?.status === 200 || response?.status === 201) {
  //       return response;
  //     }
  //   } catch (error) {
  //     if (error?.response?.data) {
  //       const errorMessage = error.response.data.message;
  //       toast.error(errorMessage);
  //     }
  //   }
  // };

  export const createPrayer=({value,id})=> async (dispatch) => {
      try {
        const response = await axios.post(`${baseUrl}/payment/prayer`, {
          FirstName:value?.FirstName,
          LastName:value?.LastName,
          email: value?.email,
          message: value?.message,
          centerId:value?.centerId
    
        });
        if(response?.status===201 || response?.status===200){
          toast.success("Prayer Created Sucessfully");
          return response
        }
      } catch (error) {
        if(error){
         const errorMessage=error.response.value.message
         toast.error(errorMessage)
        }
      }
    
  };